import React, { Fragment, useEffect } from "react";
import { useDispatch } from "react-redux";
import { useTranslation } from "react-i18next";
import { hot } from "react-hot-loader/root";

import ArcticViewer from "@/components/ArcticViewer";
import LeftPanel from "@/components/LeftPanel";
import Dashboard from "@/components/dashboard/Dashboard";
import LayerLegend from "@/components/dashboard/legend/LayerLegend";
import { actionCreators } from "@/duck/panel";
import { actionCreators as timelineActionCreators } from "@/duck/timeline";

const ArcticMap = ({ location, history }) => {
  const { i18n } = useTranslation();
  const dispatch = useDispatch();
  useEffect(() => {
    const { search } = location;
    if (!search) {
      return;
    }
    const params = new URLSearchParams(search);
    const locale = params.get("locale") || "en";
    i18n.changeLanguage(locale);
    const type = params.get("type");
    dispatch(actionCreators.panel.change({ name: "ANALYSIS" }));
    const layerGroup = type === "1" ? "route" : "remote";
    dispatch(
      timelineActionCreators.timeline.show({ currentLayerGroup: layerGroup })
    );
  }, [dispatch, location, i18n]);
  return (
    <Fragment>
      <ArcticViewer location={location} />
      <LeftPanel />
      <Dashboard />
      <LayerLegend />
    </Fragment>
  );
};

export default hot(ArcticMap);
